import { RoomSelector } from './RoomSelector/RoomSelector';
import type { CalendarEventTime, Room } from './RoomSelector/RoomSelector.types';
import type { RoomPanelOpenSourceType } from '../store/schema/RoomPanelMetricTypes';
import { observer } from 'mobx-react-lite';
import { FocusTrapZone } from '@fluentui/react/lib/FocusTrapZone';
import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import * as React from 'react';

const classNames = require('classnames');
const styles = require('./RoomPanel.scss');

export interface RoomPanelProps {
    colorScheme: ColorScheme;
    event: CalendarEventTime;
    source: RoomPanelOpenSourceType;
    hideHeader?: boolean;
    onClose?: (timeElapsed: number) => void;
    onRoomAdded?: (room: Room) => void;
}

export default observer(function RoomPanel(props: RoomPanelProps) {
    const onClose = React.useRef<(timeElapsed: number) => void>(
        props.onClose || ((timeElapsed: number) => {})
    );
    const onRoomAdded = React.useRef<(room: Room) => void>(
        props.onRoomAdded || ((room: Room) => {})
    );
    return (
        <>
            <FocusTrapZone isClickableOutsideFocusTrap={true} forceFocusInsideTrap={false}>
                <div className={classNames(styles.roomPickerPane, 'customScrollBar')}>
                    <RoomSelector
                        onRoomAdded={onRoomAdded.current}
                        onClose={onClose.current}
                        event={props.event}
                        colorScheme={props.colorScheme}
                        source={props.source}
                        hideHeader={props.hideHeader}
                    />
                </div>
            </FocusTrapZone>
        </>
    );
});
